import { Navigate, useLocation } from "react-router-dom";

export default function TrailingSlashRedirect() {
  const { pathname, search, hash } = useLocation();

  if (pathname !== "/" && pathname.endsWith("/")) {
    return (
      <Navigate
        replace
        to={`${pathname.slice(0, -1)}${search}${hash}`}
      />
    );
  }

  return null;
}
